import appStrings from 'common/app_strings';
import appColors from '../../../common/app_colors';

const {
  allLabel, mindsets, fundamentals, wellness, finances, academics, careers,
} = appStrings.goals.labels;
const { pills } = appColors;

export const filters = [
  {
    value: 'all',
    label: allLabel,
    icon: '/assets/goals/bullseye_outline.svg',
    type: 'group',
    classname: 'goals-indicator-all',
    avatarStyles: {
      backgroundColor: pills.orange2,
    },
    imgProps: {
      sx: {
        position: 'relative',
        right: '3px',
        maxWidth: '42px',
        height: '43px',
        marginLeft: '4px',
      },
    },
  },
  {
    value: 'mindsets',
    label: mindsets,
    icon: '/assets/goals/mindsets.svg',
    type: 'group',
    classname: 'goals-indicator-mindsets',
    avatarStyles: {
      backgroundColor: pills.skyBlue,
    },
    imgProps: {
      sx: {
        maxWidth: '45px',
        height: '40px',
      },
    },
  },
  {
    value: 'fundamentals',
    label: fundamentals,
    icon: '/assets/goals/fundamentals.svg',
    type: 'group',
    classname: 'goals-indicator-fundamentals',
    avatarStyles: {
      backgroundColor: pills.skyBlue,
    },
    imgProps: {
      sx: {
        maxWidth: '45px',
        height: '42px',
      },
    },
  },
  {
    value: 'wellness',
    label: wellness,
    icon: '/assets/goals/wellness.svg',
    type: 'group',
    classname: 'goals-indicator-wellness',
    avatarStyles: {
      backgroundColor: pills.lightBlue,
    },
    imgProps: {
      sx: {
        maxWidth: '49px',
        height: '40px',
      },
    },
  },
  {
    value: 'finances',
    label: finances,
    icon: '/assets/goals/finances.svg',
    type: 'group',
    classname: 'goals-indicator-finances',
    avatarStyles: {
      backgroundColor: pills.lightBlue,
    },
    imgProps: {
      sx: {
        maxWidth: '43px',
        height: '45px',
      },
    },
  },
  {
    value: 'academics',
    label: academics,
    icon: '/assets/goals/academics.svg',
    type: 'group',
    classname: 'goals-indicator-academics',
    avatarStyles: {
      backgroundColor: pills.darkBlue,
    },
    imgProps: {
      sx: {
        maxWidth: '43px',
        height: '45px',
        marginLeft: '4px',
      },
    },
  },
  {
    value: 'careers',
    label: careers,
    icon: '/assets/goals/careers.svg',
    type: 'group',
    classname: 'goals-indicator-careers',
    avatarStyles: {
      backgroundColor: pills.darkBlue,
    },
    imgProps: {
      sx: {
        maxWidth: '47px',
        height: '43px',
      },
    },
  },
];

export const goalTypeButtons = [
  {
    key: 'mindsets',
    title: 'Mindsets',
    icon: '/assets/goals/mindsets.svg',
    bgColor: pills.skyBlue,
  },
  {
    key: 'fundamentals',
    title: 'Fundamentals',
    icon: '/assets/goals/fundamentals.svg',
    bgColor: pills.skyBlue,
  },
  {
    key: 'wellness',
    title: 'Wellness',
    icon: '/assets/goals/wellness.svg',
    bgColor: pills.lightBlue,
  },
  {
    key: 'finances',
    title: 'Finances',
    icon: '/assets/goals/finances.svg',
    bgColor: pills.lightBlue,
  },
  {
    key: 'academics',
    title: 'Academics',
    icon: '/assets/goals/academics.svg',
    bgColor: pills.darkBlue,
  },
  {
    key: 'careers',
    title: 'Careers',
    icon: '/assets/goals/careers.svg',
    bgColor: pills.darkBlue,
  },
];
